/* PVS support guides in store search (2026-10-01).

   Finds the support guides that match what a shopper typed, for three places:
     - the header predictive dropdown ("Support guides" group, predictive-search.js)
     - the /search results page ("Support guides" panel, sections/main-search.liquid)
     - the search box on the /pages/support-* hubs (sections/pvs-support-kb-hub.liquid)

   The matcher and the guide index are NOT in this file. They come from the support portal,
   https://support.pvsautomotive.com.au/guide-search.js, which tools/build_hub.py GENERATES
   from the portal hub's own matcher (SEARCH-MATCHER block) and the guide corpus
   (support-articles.json). So the store and the portal rank guides the same way and a
   new guide reaches the store without a theme push. The ?v= stamp is the day, so the
   portal's one-day cache on a ?v= request is the most a change can lag.

   If that file cannot load, guides() falls back to Shopify's own predictive search for
   pages (handles starting support- only). That index matches titles only, so it is the
   weaker of the two, but a shopper still gets a guide rather than nothing.

   ⛔ Only /pages/support-* reaches a shopper from here: never a policy, about or other page. */
(function (w, d) {
  'use strict';
  if (w.PVSSupportGuides) { return; }

  var PORTAL = 'https://support.pvsautomotive.com.au';
  /* REV: bump it (and push this file) when the portal's matcher changes in a way the store
     must see TODAY. Otherwise the day stamp alone picks up a new build within a day. */
  var REV = '5';  // 5: 2026-10-06 steering install guides (20 guides + install hub)
  var day = new Date();
  var SRC = PORTAL + '/guide-search.js?v=' + day.getFullYear() + ('0' + (day.getMonth() + 1)).slice(-2) + ('0' + day.getDate()).slice(-2) + 'r' + REV;
  var state = 0;        /* 0 not asked, 1 loading, 2 ready, 3 failed */
  var waiting = [];

  function flush() {
    var list = waiting;
    waiting = [];
    for (var i = 0; i < list.length; i++) {
      try { list[i](w.PVSGuideSearch || null); } catch (e) { /* one caller never breaks another */ }
    }
  }

  /* cb(api) once the portal matcher is ready, or cb(null) if it could not load. */
  function load(cb) {
    if (w.PVSGuideSearch) { state = 2; if (cb) { cb(w.PVSGuideSearch); } return; }
    if (cb) { waiting.push(cb); }
    if (state === 3) { flush(); return; }
    if (state === 1) { return; }
    state = 1;
    var s = d.createElement('script');
    s.src = SRC;
    s.async = true;
    var timer = setTimeout(function () { if (state === 1) { state = 3; flush(); } }, 6000);
    s.onload = function () { clearTimeout(timer); state = w.PVSGuideSearch ? 2 : 3; flush(); };
    s.onerror = function () { clearTimeout(timer); state = 3; flush(); };
    (d.head || d.documentElement).appendChild(s);
  }

  function isGuide(handle) { return typeof handle === 'string' && handle.indexOf('support-') === 0; }

  /* A guide that moved to the support domain (wave 1, 16 Oct 2026) links straight to its new
     address: PVSGuideSearch.moved[handle] from the generated guide-search.js. Anything else, or a
     bundle without the map, keeps /pages/<handle>. */
  function guideUrl(api, handle) {
    var m = api && api.moved;
    var u = m && Object.prototype.hasOwnProperty.call(m, handle) ? m[handle] : '';
    return (typeof u === 'string' && u.indexOf('https://') === 0) ? u : '/pages/' + handle;
  }

  /* Up to n guides for q, best first: [{ title, url, hub, summary, strong }]. `strong` = the
     words typed are one of the guide's own tags (see the portal matcher). Only guides that
     match EVERY word typed (bar stop words), so a broad product query does not drag in a
     guide that shares one word with it. */
  function fromMatcher(api, q, n) {
    var hits = api.search(q, 60), out = [];
    for (var i = 0; i < hits.length && out.length < n; i++) {
      var r = hits[i].row;
      if (!hits[i].full || !isGuide(r[1])) { continue; }
      out.push({ title: r[0], url: guideUrl(api, r[1]), hub: r[2] || '', summary: r[3] || '', strong: !!hits[i].strong });
    }
    return out;
  }

  function fromShopify(q, n, cb) {
    var url = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root ? w.Shopify.routes.root : '/') +
      'search/suggest.json?q=' + encodeURIComponent(q) +
      '&' + encodeURIComponent('resources[type]') + '=page' +
      '&' + encodeURIComponent('resources[limit]') + '=10';
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
      var pages = (j && j.resources && j.resources.results && j.resources.results.pages) || [], out = [];
      for (var i = 0; i < pages.length && out.length < n; i++) {
        if (isGuide(pages[i].handle)) { out.push({ title: pages[i].title, url: guideUrl(w.PVSGuideSearch, pages[i].handle), hub: '', summary: '' }); }
      }
      cb(out);
    }).catch(function () { cb([]); });
  }

  function guides(q, n, cb) {
    q = String(q || '').replace(/\s+/g, ' ').trim().slice(0, 100);
    if (q.length < 2) { cb([]); return; }
    load(function (api) {
      if (api) {
        var out = [];
        try { out = fromMatcher(api, q, n); } catch (e) { api = null; }
        if (api) { cb(out); return; }
      }
      fromShopify(q, n, cb);
    });
  }

  function esc(v) {
    return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* The portal hub with the shopper's words already searched. */
  function portalUrl(q) {
    q = String(q || '').replace(/\s+/g, ' ').trim().slice(0, 100);
    return PORTAL + '/' + (q ? '?q=' + encodeURIComponent(q) : '');
  }

  w.PVSSupportGuides = { load: load, guides: guides, esc: esc, portalUrl: portalUrl };
}(window, document));
